module.exports = __webpack_public_path__ + "img/orange.b175f77a.png";